<template>
    <div class="drawing-space">
        <main id="main" class="container-fluid clearfix">
            <Navbar></Navbar>

            <div class="wrapper full-width">

                <!-- #working_space -->
                <div id="working_space" class="sidebar sidebar-1 dark-mode">
                    <div class="inner">
                        <div class="screen-tools">
                            <button @click="backPage" class="zoom"><img src="@/assets/images/zoom-out-cyan.svg"
                                                                        class="svg"/></button>
                        </div>

                        <div class="row">
                            <div class="col-xl-10 col-lg-12 col-md-12 col-sm-12">
                                <!--#ssv_drawing_space-->
                                <div class="canvas-tools">
                                    <button @click="selectItem()"><i class="fa fa-arrows-alt" aria-hidden="true"></i>
                                    </button>
                                    <button @click="draw()"><i class="fas fa-pencil-alt"></i></button>
                                    <select @change="selectStorck" class="pen-size" name="strock"
                                            v-model="default_strock" id="">
                                        <option v-for="(strock,index) in strocks" :value="strock" :key="index">
                                            {{strock}}
                                        </option>
                                    </select>
                                    <button @click="setLine()"><i class='fas fa-pen-nib'></i>
                                    </button>
                                    <button @click="addText()"><i class="fa fa-font"></i></button>
                                    <button @click="undo()" type="button"><i class="fas fa-undo"></i></button>
                                    <button @click="redo()" type="button"><i class="fas fa-redo"></i></button>

                                    <button @click="deleteObject()"><i class="fas fa-trash"></i></button>
                                    <button @click="saveImage" type="button"><i class="fa fa-download"></i></button>
                                    <button @click="setArrow()"><i class="fa fa-arrow-right" aria-hidden="true"></i>
                                    </button>
                                    <button v-for="(color, index) in colors" :key="index" class="color"
                                            :style="'background:'+color" @click="selectColor(color)"></button>
                                    <button @click="zoomIn" class="svg-zoom" type="button"><i
                                            class="fa fa-search-plus" aria-hidden="true"></i></button>
                                    <button @click="zoomOut" class="" type="button"><i
                                            class="fa fa-search-minus" aria-hidden="true"></i></button>
                                    <span @click="sendImage" class="float-right w-auto save-svg">Save</span>
                                    <span @click="clear()" class="float-right w-auto discard-svg">Discard</span>
                                </div>
                                <div id="ssv_drawing_space" class="ssv_drawing_space">
                                    <Editor :canvasWidth="850" :canvasHeight="500" ref="editor" editorId="canvasId"/>
                                </div>
                                <!-- end #ssv_drawing_space -->
                            </div>
                            <div class=" svg-images">
                                <div id="frontSvg"  @click="selectSvg('frontSvg', 'GSV')"
                                     :class="'svgItem front svg-image ' + selectedSvgClass('frontSvg')">
                                    <HumanBodyFront :draggable="false"/>
                                </div>
                                <h4 class="svg-name">GSV</h4>
                                <div id="backSvg" @click="selectSvg('backSvg', 'SSV')"
                                     :class="'svgItem back ' + selectedSvgClass('backSvg')">
                                    <HumanBodyBack :draggable="false"/>
                                </div>
                                <h4 class="svg-name">SSV</h4>
                            </div>
                            <!-- #study_details -->
                            <div class="col-xl-2 col-lg-12 col-md-12 col-sm-12">
                                <!-- #reports -->
                                <div class="panel-group study-info" id="study_details">
                                    <div class="panel panel-default">
                                        <div class="panel-heading">
                                            <h4 class="panel-title">
                                                <a data-toggle="collapse" data-parent="#study_details"
                                                   href="#collapse_findings" aria-expanded="true">Findings <span
                                                        class="panel-arrow"></span></a>
                                            </h4>
                                        </div>
                                        <div id="collapse_findings" class="panel-collapse collapse in show">
                                            <div class="panel-body scrolling">
                                                <ul class="list-group">
                                                    <li class="list-group-item">
                                                        <h5 id="right-find">Right Findings</h5>
                                                        <p id="rightFindings_value">{{study.rightFindings}}</p>
                                                    </li>
                                                    <li class="list-group-item">
                                                        <h5 id="left-find">Left Findings</h5>
                                                        <p id="leftFindings_value">{{study.leftFindings}}</p>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="panel panel-default">
                                        <div class="panel-heading">
                                            <h4 class="panel-title">
                                                <a data-toggle="collapse" data-parent="#study_details"
                                                   href="#collapse_recommendations">Recommendations <span
                                                        class="panel-arrow"></span></a>
                                            </h4>
                                        </div>
                                        <div id="collapse_recommendations" class="panel-collapse collapse in">
                                            <div class="panel-body scrolling">
                                                <p id="recommendations_value">{{study.recommendations}}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="panel panel-default">
                                        <div class="panel-heading">
                                            <h4 class="panel-title">
                                                <a data-toggle="collapse" data-parent="#study_details"
                                                   href="#collapse_results">Results <span
                                                        class="panel-arrow"></span></a>
                                            </h4>
                                        </div>
                                        <div id="collapse_results" class="panel-collapse collapse in">
                                            <div class="panel-body scrolling">
                                                <p id="results_value">{{study.results}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div><!-- end #study_details -->
                            </div>
                        </div>
                    </div>
                </div>
                <!-- end #working_space -->

            </div>

        </main>
    </div>
</template>
<script>
    import Navbar from '../layouts/components/TheNavbar.vue';
    import StudyService from '../services/StudyService';
    import moment from 'moment';
    import Editor from '../Editor';
    import HumanBodyFront from "./HumanBodyFront";
    import HumanBodyBack from "./HumanBodyBack";
    import $ from 'jquery'
    import moduleStudy from '../store/study/moduleStudy'

    export default {
        name: 'DrawingSpace',
        components: {
            Navbar,
            Editor,
            HumanBodyFront,
            HumanBodyBack
        },
        data() {
            return {
                study: '',
                veins: [],
                newCanvasWidth: 850,
                newCanvasHeight: 500,
                ssvVeins: [],
                deepVeins: [],
                images: [],
                canvasWidth: '',
                canvasHeight: '',
                editor: {
                    mode: 'freeDrawing'
                },
                is_crop: false,
                colors: ['red', 'black', 'blue'],
                strocks: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
                default_color: 'black',
                default_strock: 1,
                zoom: 1,
                selectedSvg: '',
                veinType: null,
                prevRoute: null
            }
        },

        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.prevRoute = from
            })
        },

        computed: {
            selectedSvgClass() {
                return (className) => {
                    return this.selectedSvg === className ? 'active' : ''
                }
            }
        },

        mounted() {
            this.$store.commit('setLoading', false)
            let customizeFreeDrawing = {stroke: this.default_color, strokeWidth: this.default_strock}
            this.$refs.editor.set(this.editor.mode, customizeFreeDrawing);
        },
        async created() {
            if (!moduleStudy.isRegistered) {
                this.$store.registerModule('studyInfoStore', moduleStudy)
                moduleStudy.isRegistered = true
            }
            this.getStudiesById(this.$route.params.id);
            this.getVeinImage();
        },

        methods: {
            getRequestParam: function (name) {
                if ((name = (new RegExp('[?&]' + encodeURIComponent(name) + '=([^&]*)')).exec(location.search)))
                    return decodeURIComponent(name[1]);

            },

            async getStudiesById(id) {

                await StudyService.getStudyDataById(id)
                    .then((response) => {
                        this.study = response.data;
                        this.veins = response.data.veins.gsv;
                        this.ssvVeins = response.data.veins.ssv;
                        this.deepVeins = response.data.veins.deapVeins;
                        this.updateVeinColors(this.veins, this.ssvVeins)
                    })
                    .catch((error) => {
                        console.log(error);
                    })
            },

            updateVeinColors(veins, ssv_veins) {
                veins.forEach((item) => {
                    if (item.laterality === 'Left') {
                        if (item.topographicalModifier === 'Distal Thigh') {
                            if (item.refluxTime < 0.5) {
                                // Blue color
                                this.$store.commit('UPDATE_COLORS', {index: 'color_gsv_56', color: '#00a1de'})
                            } else if (item.refluxTime >= 0.5 && item.refluxTime < 1) {
                                // Red Color
                                this.$store.commit('UPDATE_COLORS', {index: 'color_gsv_56', color: '#FF2735'})
                            } else {
                                // Dark red Color
                                this.$store.commit('UPDATE_COLORS', {index: 'color_gsv_56', color: '#800000'})
                            }

                            if (item.visualLumen === 'Phasic Flow') {
                                // Transparent
                                this.$store.commit('UPDATE_DOT_COLORS', {
                                    index: 'dot_25',
                                    partial_index: 'partial_13',
                                    color: 'transparent',
                                    partial: 'transparent'
                                })
                                this.$store.commit('UPDATE_DOT_COLORS', {
                                    index: 'dot_26',
                                    partial_index: 'partial_13',
                                    color: 'transparent',
                                    partial: 'transparent'
                                })
                            } else if (item.visualLumen === 'Clotted Partial') {
                                // 3 dots
                                this.$store.commit('UPDATE_DOT_COLORS', {
                                    index: 'dot_25',
                                    partial_index: 'partial_13',
                                    color: 'transparent',
                                    partial: 'black'
                                })
                                this.$store.commit('UPDATE_DOT_COLORS', {
                                    index: 'dot_26',
                                    partial_index: 'partial_13',
                                    color: 'transparent',
                                    partial: 'black'
                                })
                            } else {
                                // 6 dots
                                this.$store.commit('UPDATE_DOT_COLORS', {
                                    index: 'dot_25',
                                    partial_index: 'partial_13',
                                    color: 'black',
                                    partial: 'transparent'
                                })
                                this.$store.commit('UPDATE_DOT_COLORS', {
                                    index: 'dot_26',
                                    partial_index: 'partial_13',
                                    color: 'black',
                                    partial: 'transparent'
                                })
                            }
                        }
                        if (item.topographicalModifier === 'Mid Thigh') {
                            if (item.refluxTime < 0.5) {
                                // Blue color
                                this.$store.commit('UPDATE_COLORS', {index: 'color_gsv_50', color: '#00a1de'})
                            } else if (item.refluxTime >= 0.5 && item.refluxTime < 1) {
                                // Red Color
                                this.$store.commit('UPDATE_COLORS', {index: 'color_gsv_50', color: '#FF2735'})
                            } else {
                                // Dark red Color
                                this.$store.commit('UPDATE_COLORS', {index: 'color_gsv_50', color: '#800000'})
                            }

                            if (item.visualLumen === 'Phasic Flow') {
                                // Transparent
                                this.$store.commit('UPDATE_DOT_COLORS', {
                                    index: 'dot_13',
                                    partial_index: 'partial_7',
                                    color: 'transparent',
                                    partial: 'transparent'
                                })
                                this.$store.commit('UPDATE_DOT_COLORS', {
                                    index: 'dot_14',
                                    partial_index: 'partial_7',
                                    color: 'transparent',
                                    partial: 'transparent'
                                })
                            } else if (item.visualLumen === 'Clotted Partial') {
                                // 3 dots
                                this.$store.commit('UPDATE_DOT_COLORS', {
                                    index: 'dot_13',
                                    partial_index: 'partial_7',
                                    color: 'transparent',
                                    partial: 'black'
                                })
                                this.$store.commit('UPDATE_DOT_COLORS', {
                                    index: 'dot_14',
                                    partial_index: 'partial_7',
                                    color: 'transparent',
                                    partial: 'black'
                                })
                            } else {
                                // 6 dots
                                this.$store.commit('UPDATE_DOT_COLORS', {
                                    index: 'dot_13',
                                    partial_index: 'partial_7',
                                    color: 'black',
                                    partial: 'transparent'
                                })
                                this.$store.commit('UPDATE_DOT_COLORS', {
                                    index: 'dot_14',
                                    partial_index: 'partial_7',
                                    color: 'black',
                                    partial: 'transparent'
                                })
                            }
                        }
                        if (item.topographicalModifier === 'Proximal Thigh') {
                            if (item.refluxTime < 0.5) {
                                // Blue color
                                this.$store.commit('UPDATE_COLORS', {index: 'color_gsv_48', color: '#00a1de'})
                            } else if (item.refluxTime >= 0.5 && item.refluxTime < 1) {
                                // Red Color
                                this.$store.commit('UPDATE_COLORS', {index: 'color_gsv_48', color: '#FF2735'})
                            } else {
                                // Dark red Color
                                this.$store.commit('UPDATE_COLORS', {index: 'color_gsv_48', color: '#800000'})
                            }
                            if (item.visualLumen === 'Phasic Flow') {
                                // Transparent
                                this.$store.commit('UPDATE_DOT_COLORS', {
                                    index: 'dot_9',
                                    partial_index: 'partial_5',
                                    color: 'transparent',
                                    partial: 'transparent'
                                })
                                this.$store.commit('UPDATE_DOT_COLORS', {
                                    index: 'dot_10',
                                    partial_index: 'partial_5',
                                    color: 'transparent',
                                    partial: 'transparent'
                                })
                            } else if (item.visualLumen === 'Clotted Partial') {
                                // 3 dots
                                this.$store.commit('UPDATE_DOT_COLORS', {
                                    index: 'dot_9',
                                    partial_index: 'partial_5',
                                    color: 'transparent',
                                    partial: 'black'
                                })
                                this.$store.commit('UPDATE_DOT_COLORS', {
                                    index: 'dot_10',
                                    partial_index: 'partial_5',
                                    color: 'transparent',
                                    partial: 'black'
                                })
                            } else {
                                // 6 dots
                                this.$store.commit('UPDATE_DOT_COLORS', {
                                    index: 'dot_9',
                                    partial_index: 'partial_5',
                                    color: 'black',
                                    partial: 'transparent'
                                })
                                this.$store.commit('UPDATE_DOT_COLORS', {
                                    index: 'dot_10',
                                    partial_index: 'partial_5',
                                    color: 'black',
                                    partial: 'transparent'
                                })
                            }
                        }
                        if (item.name === 'SFJ') {
                            if (item.refluxTime < 0.5) {
                                // Blue color
                                this.$store.commit('UPDATE_COLORS', {index: 'color_gsv_46', color: '#00a1de'})
                            } else if (item.refluxTime >= 0.5 && item.refluxTime < 1) {
                                // Red Color
                                this.$store.commit('UPDATE_COLORS', {index: 'color_gsv_46', color: '#FF2735'})
                            } else {
                                // Dark red Color
                                this.$store.commit('UPDATE_COLORS', {index: 'color_gsv_46', color: '#800000'})
                            }
                            if (item.visualLumen === 'Phasic Flow') {
                                // Transparent
                                this.$store.commit('UPDATE_DOT_COLORS', {
                                    index: 'dot_3',
                                    partial_index: 'partial_2',
                                    color: 'transparent',
                                    partial: 'transparent'
                                })
                                this.$store.commit('UPDATE_DOT_COLORS', {
                                    index: 'dot_4',
                                    partial_index: 'partial_2',
                                    color: 'transparent',
                                    partial: 'transparent'
                                })
                            } else if (item.visualLumen === 'Clotted Partial') {
                                // 3 dots
                                this.$store.commit('UPDATE_DOT_COLORS', {
                                    index: 'dot_3',
                                    partial_index: 'partial_2',
                                    color: 'transparent',
                                    partial: 'black'
                                })
                                this.$store.commit('UPDATE_DOT_COLORS', {
                                    index: 'dot_4',
                                    partial_index: 'partial_2',
                                    color: 'transparent',
                                    partial: 'black'
                                })
                            } else {
                                // 6 dots
                                this.$store.commit('UPDATE_DOT_COLORS', {
                                    index: 'dot_3',
                                    partial_index: 'partial_2',
                                    color: 'black',
                                    partial: 'transparent'
                                })
                                this.$store.commit('UPDATE_DOT_COLORS', {
                                    index: 'dot_4',
                                    partial_index: 'partial_2',
                                    color: 'black',
                                    partial: 'transparent'
                                })
                            }
                        }
                    } else {
                        if (item.topographicalModifier === 'Distal Thigh') {
                            if (item.refluxTime < 0.5) {
                                // Blue color
                                this.$store.commit('UPDATE_COLORS', {index: 'color_gsv_55', color: '#00a1de'})
                            } else if (item.refluxTime >= 0.5 && item.refluxTime < 1) {
                                // Red Color
                                this.$store.commit('UPDATE_COLORS', {index: 'color_gsv_55', color: '#FF2735'})
                            } else {
                                // Dark red Color
                                this.$store.commit('UPDATE_COLORS', {index: 'color_gsv_55', color: '#800000'})
                            }

                            if (item.visualLumen === 'Phasic Flow') {
                                // Transparent
                                this.$store.commit('UPDATE_DOT_COLORS', {
                                    index: 'dot_23',
                                    partial_index: 'partial_12',
                                    color: 'transparent',
                                    partial: 'transparent'
                                })
                                this.$store.commit('UPDATE_DOT_COLORS', {
                                    index: 'dot_24',
                                    partial_index: 'partial_12',
                                    color: 'transparent',
                                    partial: 'transparent'
                                })
                            } else if (item.visualLumen === 'Clotted Partial') {
                                // 3 dots
                                this.$store.commit('UPDATE_DOT_COLORS', {
                                    index: 'dot_23',
                                    partial_index: 'partial_12',
                                    color: 'transparent',
                                    partial: 'black'
                                })
                                this.$store.commit('UPDATE_DOT_COLORS', {
                                    index: 'dot_24',
                                    partial_index: 'partial_12',
                                    color: 'transparent',
                                    partial: 'black'
                                })
                            } else {
                                // 6 dots
                                this.$store.commit('UPDATE_DOT_COLORS', {
                                    index: 'dot_23',
                                    partial_index: 'partial_12',
                                    color: 'black',
                                    partial: 'transparent'
                                })
                                this.$store.commit('UPDATE_DOT_COLORS', {
                                    index: 'dot_24',
                                    partial_index: 'partial_12',
                                    color: 'black',
                                    partial: 'transparent'
                                })
                            }
                        }
                        if (item.topographicalModifier === 'Mid Thigh') {
                            if (item.refluxTime < 0.5) {
                                // Blue color
                                this.$store.commit('UPDATE_COLORS', {index: 'color_gsv_49', color: '#00a1de'})
                            } else if (item.refluxTime >= 0.5 && item.refluxTime < 1) {
                                // Red Color
                                this.$store.commit('UPDATE_COLORS', {index: 'color_gsv_49', color: '#FF2735'})
                            } else {
                                // Dark red Color
                                this.$store.commit('UPDATE_COLORS', {index: 'color_gsv_49', color: '#800000'})
                            }
                            if (item.visualLumen === 'Phasic Flow') {
                                // Transparent
                                this.$store.commit('UPDATE_DOT_COLORS', {
                                    index: 'dot_11',
                                    partial_index: 'partial_6',
                                    color: 'transparent',
                                    partial: 'transparent'
                                })
                                this.$store.commit('UPDATE_DOT_COLORS', {
                                    index: 'dot_12',
                                    partial_index: 'partial_6',
                                    color: 'transparent',
                                    partial: 'transparent'
                                })
                            } else if (item.visualLumen === 'Clotted Partial') {
                                // 3 dots
                                this.$store.commit('UPDATE_DOT_COLORS', {
                                    index: 'dot_11',
                                    partial_index: 'partial_6',
                                    color: 'transparent',
                                    partial: 'black'
                                })
                                this.$store.commit('UPDATE_DOT_COLORS', {
                                    index: 'dot_12',
                                    partial_index: 'partial_6',
                                    color: 'transparent',
                                    partial: 'black'
                                })
                            } else {
                                // 6 dots
                                this.$store.commit('UPDATE_DOT_COLORS', {
                                    index: 'dot_11',
                                    partial_index: 'partial_6',
                                    color: 'black',
                                    partial: 'transparent'
                                })
                                this.$store.commit('UPDATE_DOT_COLORS', {
                                    index: 'dot_12',
                                    partial_index: 'partial_6',
                                    color: 'black',
                                    partial: 'transparent'
                                })
                            }
                        }
                        if (item.topographicalModifier === 'Proximal Thigh') {
                            if (item.refluxTime < 0.5) {
                                // Blue color
                                this.$store.commit('UPDATE_COLORS', {index: 'color_gsv_47', color: '#00a1de'})
                            } else if (item.refluxTime >= 0.5 && item.refluxTime < 1) {
                                // Red Color
                                this.$store.commit('UPDATE_COLORS', {index: 'color_gsv_47', color: '#FF2735'})
                            } else {
                                // Dark red Color
                                this.$store.commit('UPDATE_COLORS', {index: 'color_gsv_47', color: '#800000'})
                            }

                            if (item.visualLumen === 'Phasic Flow') {
                                // Transparent
                                this.$store.commit('UPDATE_DOT_COLORS', {
                                    index: 'dot_7',
                                    partial_index: 'partial_4',
                                    color: 'transparent',
                                    partial: 'transparent'
                                })
                                this.$store.commit('UPDATE_DOT_COLORS', {
                                    index: 'dot_8',
                                    partial_index: 'partial_4',
                                    color: 'transparent',
                                    partial: 'transparent'
                                })
                            } else if (item.visualLumen === 'Clotted Partial') {
                                // 3 dots
                                this.$store.commit('UPDATE_DOT_COLORS', {
                                    index: 'dot_7',
                                    partial_index: 'partial_4',
                                    color: 'transparent',
                                    partial: 'black'
                                })
                                this.$store.commit('UPDATE_DOT_COLORS', {
                                    index: 'dot_8',
                                    partial_index: 'partial_4',
                                    color: 'transparent',
                                    partial: 'black'
                                })
                            } else {
                                // 6 dots
                                this.$store.commit('UPDATE_DOT_COLORS', {
                                    index: 'dot_7',
                                    partial_index: 'partial_4',
                                    color: 'black',
                                    partial: 'transparent'
                                })
                                this.$store.commit('UPDATE_DOT_COLORS', {
                                    index: 'dot_8',
                                    partial_index: 'partial_4',
                                    color: 'black',
                                    partial: 'transparent'
                                })
                            }
                        }
                        if (item.name === 'SFJ') {
                            if (item.refluxTime < 0.5) {
                                // Blue color
                                this.$store.commit('UPDATE_COLORS', {index: 'color_gsv_45', color: '#00a1de'})
                            } else if (item.refluxTime >= 0.5 && item.refluxTime < 1) {
                                // Red Color
                                this.$store.commit('UPDATE_COLORS', {index: 'color_gsv_45', color: '#FF2735'})
                            } else {
                                // Dark red Color
                                this.$store.commit('UPDATE_COLORS', {index: 'color_gsv_45', color: '#800000'})
                            }
                            if (item.visualLumen === 'Phasic Flow') {
                                // Transparent
                                this.$store.commit('UPDATE_DOT_COLORS', {
                                    index: 'dot_1',
                                    partial_index: 'partial_1',
                                    color: 'transparent',
                                    partial: 'transparent'
                                })
                                this.$store.commit('UPDATE_DOT_COLORS', {
                                    index: 'dot_2',
                                    partial_index: 'partial_1',
                                    color: 'transparent',
                                    partial: 'transparent'
                                })
                            } else if (item.visualLumen === 'Clotted Partial') {
                                // 3 dots
                                this.$store.commit('UPDATE_DOT_COLORS', {
                                    index: 'dot_1',
                                    partial_index: 'partial_1',
                                    color: 'transparent',
                                    partial: 'black'
                                })
                                this.$store.commit('UPDATE_DOT_COLORS', {
                                    index: 'dot_2',
                                    partial_index: 'partial_1',
                                    color: 'transparent',
                                    partial: 'black'
                                })
                            } else {
                                // 6 dots
                                this.$store.commit('UPDATE_DOT_COLORS', {
                                    index: 'dot_1',
                                    partial_index: 'partial_1',
                                    color: 'black',
                                    partial: 'transparent'
                                })
                                this.$store.commit('UPDATE_DOT_COLORS', {
                                    index: 'dot_2',
                                    partial_index: 'partial_1',
                                    color: 'black',
                                    partial: 'transparent'
                                })
                            }
                        }
                    }

                })

                ssv_veins.forEach((item) => {
                    if (item.laterality === 'Left') {
                        if (item.topographicalModifier === 'Ankle') {
                            if (item.refluxTime < 0.5) {
                                // Blue color
                                this.$store.commit('UPDATE_SSV_COLORS', {index: 'color_ssv_5', color: '#8ec4dd'})
                            } else if (item.refluxTime >= 0.5 && item.refluxTime < 1) {
                                // Red Color
                                this.$store.commit('UPDATE_SSV_COLORS', {index: 'color_ssv_5', color: '#FF2735'})
                            } else {
                                // Dark red Color
                                this.$store.commit('UPDATE_SSV_COLORS', {index: 'color_ssv_5', color: '#800000'})
                            }

                            if (item.visualLumen === 'Phasic Flow') {
                                // Transparent
                                this.$store.commit('UPDATE_SSV_DOT_COLORS', {
                                    index: 'dot_9',
                                    partial_index: 'partial_5',
                                    color: 'transparent',
                                    partial: 'transparent'
                                })
                                this.$store.commit('UPDATE_SSV_DOT_COLORS', {
                                    index: 'dot_10',
                                    partial_index: 'partial_5',
                                    color: 'transparent',
                                    partial: 'transparent'
                                })
                            } else if (item.visualLumen === 'Clotted Partial') {
                                // 3 dots
                                this.$store.commit('UPDATE_SSV_DOT_COLORS', {
                                    index: 'dot_9',
                                    partial_index: 'partial_5',
                                    color: 'transparent',
                                    partial: 'black'
                                })
                                this.$store.commit('UPDATE_SSV_DOT_COLORS', {
                                    index: 'dot_10',
                                    partial_index: 'partial_5',
                                    color: 'transparent',
                                    partial: 'black'
                                })
                            } else {
                                // 6 dots
                                this.$store.commit('UPDATE_SSV_DOT_COLORS', {
                                    index: 'dot_9',
                                    partial_index: 'partial_5',
                                    color: 'black',
                                    partial: 'transparent'
                                })
                                this.$store.commit('UPDATE_SSV_DOT_COLORS', {
                                    index: 'dot_10',
                                    partial_index: 'partial_5',
                                    color: 'black',
                                    partial: 'transparent'
                                })
                            }
                        }
                        if (item.topographicalModifier === 'Calf') {
                            if (item.refluxTime < 0.5) {
                                // Blue color
                                this.$store.commit('UPDATE_SSV_COLORS', {index: 'color_ssv_3', color: '#8ec4dd'})
                            } else if (item.refluxTime >= 0.5 && item.refluxTime < 1) {
                                // Red Color
                                this.$store.commit('UPDATE_SSV_COLORS', {index: 'color_ssv_3', color: '#FF2735'})
                            } else {
                                // Dark red Color
                                this.$store.commit('UPDATE_SSV_COLORS', {index: 'color_ssv_3', color: '#800000'})
                            }

                            if (item.visualLumen === 'Phasic Flow') {
                                // Transparent
                                this.$store.commit('UPDATE_SSV_DOT_COLORS', {
                                    index: 'dot_5',
                                    partial_index: 'partial_3',
                                    color: 'transparent',
                                    partial: 'transparent'
                                })
                                this.$store.commit('UPDATE_SSV_DOT_COLORS', {
                                    index: 'dot_6',
                                    partial_index: 'partial_3',
                                    color: 'transparent',
                                    partial: 'transparent'
                                })
                            } else if (item.visualLumen === 'Clotted Partial') {
                                // 3 dots
                                this.$store.commit('UPDATE_SSV_DOT_COLORS', {
                                    index: 'dot_5',
                                    partial_index: 'partial_3',
                                    color: 'transparent',
                                    partial: 'black'
                                })
                                this.$store.commit('UPDATE_SSV_DOT_COLORS', {
                                    index: 'dot_6',
                                    partial_index: 'partial_3',
                                    color: 'transparent',
                                    partial: 'black'
                                })
                            } else {
                                // 6 dots
                                this.$store.commit('UPDATE_SSV_DOT_COLORS', {
                                    index: 'dot_5',
                                    partial_index: 'partial_3',
                                    color: 'black',
                                    partial: 'transparent'
                                })
                                this.$store.commit('UPDATE_SSV_DOT_COLORS', {
                                    index: 'dot_6',
                                    partial_index: 'partial_3',
                                    color: 'black',
                                    partial: 'transparent'
                                })
                            }
                        }
                        if (item.name === 'SPJ') {
                            if (item.refluxTime < 0.5) {
                                // Blue color
                                this.$store.commit('UPDATE_SSV_COLORS', {index: 'color_ssv_6', color: '#8ec4dd'})
                            } else if (item.refluxTime >= 0.5 && item.refluxTime < 1) {
                                // Red Color
                                this.$store.commit('UPDATE_SSV_COLORS', {index: 'color_ssv_6', color: '#FF2735'})
                            } else {
                                // Dark red Color
                                this.$store.commit('UPDATE_SSV_COLORS', {index: 'color_ssv_6', color: '#800000'})
                            }

                            if (item.visualLumen === 'Phasic Flow') {
                                // Transparent
                                this.$store.commit('UPDATE_SSV_DOT_COLORS', {
                                    index: 'dot_11',
                                    partial_index: 'partial_6',
                                    color: 'transparent',
                                    partial: 'transparent'
                                })
                                this.$store.commit('UPDATE_SSV_DOT_COLORS', {
                                    index: 'dot_12',
                                    partial_index: 'partial_6',
                                    color: 'transparent',
                                    partial: 'transparent'
                                })
                            } else if (item.visualLumen === 'Clotted Partial') {
                                // 3 dots
                                this.$store.commit('UPDATE_SSV_DOT_COLORS', {
                                    index: 'dot_11',
                                    partial_index: 'partial_6',
                                    color: 'transparent',
                                    partial: 'black'
                                })
                                this.$store.commit('UPDATE_SSV_DOT_COLORS', {
                                    index: 'dot_12',
                                    partial_index: 'partial_6',
                                    color: 'transparent',
                                    partial: 'black'
                                })
                            } else {
                                // 6 dots
                                this.$store.commit('UPDATE_SSV_DOT_COLORS', {
                                    index: 'dot_11',
                                    partial_index: 'partial_6',
                                    color: 'black',
                                    partial: 'transparent'
                                })
                                this.$store.commit('UPDATE_SSV_DOT_COLORS', {
                                    index: 'dot_12',
                                    partial_index: 'partial_6',
                                    color: 'black',
                                    partial: 'transparent'
                                })
                            }
                        }
                    } else {
                        if (item.topographicalModifier === 'Ankle') {
                            if (item.refluxTime < 0.5) {
                                // Blue color
                                this.$store.commit('UPDATE_SSV_COLORS', {index: 'color_ssv_4', color: '#8ec4dd'})
                            } else if (item.refluxTime >= 0.5 && item.refluxTime < 1) {
                                // Red Color
                                this.$store.commit('UPDATE_SSV_COLORS', {index: 'color_ssv_4', color: '#FF2735'})
                            } else {
                                // Dark red Color
                                this.$store.commit('UPDATE_SSV_COLORS', {index: 'color_ssv_4', color: '#800000'})
                            }

                            if (item.visualLumen === 'Phasic Flow') {
                                // Transparent
                                this.$store.commit('UPDATE_SSV_DOT_COLORS', {
                                    index: 'dot_7',
                                    partial_index: 'partial_4',
                                    color: 'transparent',
                                    partial: 'transparent'
                                })
                                this.$store.commit('UPDATE_SSV_DOT_COLORS', {
                                    index: 'dot_8',
                                    partial_index: 'partial_4',
                                    color: 'transparent',
                                    partial: 'transparent'
                                })
                            } else if (item.visualLumen === 'Clotted Partial') {
                                // 3 dots
                                this.$store.commit('UPDATE_SSV_DOT_COLORS', {
                                    index: 'dot_7',
                                    partial_index: 'partial_4',
                                    color: 'transparent',
                                    partial: 'black'
                                })
                                this.$store.commit('UPDATE_SSV_DOT_COLORS', {
                                    index: 'dot_8',
                                    partial_index: 'partial_4',
                                    color: 'transparent',
                                    partial: 'black'
                                })
                            } else {
                                // 6 dots
                                this.$store.commit('UPDATE_SSV_DOT_COLORS', {
                                    index: 'dot_7',
                                    partial_index: 'partial_4',
                                    color: 'black',
                                    partial: 'transparent'
                                })
                                this.$store.commit('UPDATE_SSV_DOT_COLORS', {
                                    index: 'dot_8',
                                    partial_index: 'partial_4',
                                    color: 'black',
                                    partial: 'transparent'
                                })
                            }
                        }
                        if (item.topographicalModifier === 'Calf') {
                            if (item.refluxTime < 0.5) {
                                // Blue color
                                this.$store.commit('UPDATE_SSV_COLORS', {index: 'color_ssv_2', color: '#8ec4dd'})
                            } else if (item.refluxTime >= 0.5 && item.refluxTime < 1) {
                                // Red Color
                                this.$store.commit('UPDATE_SSV_COLORS', {index: 'color_ssv_2', color: '#FF2735'})
                            } else {
                                // Dark red Color
                                this.$store.commit('UPDATE_SSV_COLORS', {index: 'color_ssv_2', color: '#800000'})
                            }

                            if (item.visualLumen === 'Phasic Flow') {
                                // Transparent
                                this.$store.commit('UPDATE_SSV_DOT_COLORS', {
                                    index: 'dot_3',
                                    partial_index: 'partial_2',
                                    color: 'transparent',
                                    partial: 'transparent'
                                })
                                this.$store.commit('UPDATE_SSV_DOT_COLORS', {
                                    index: 'dot_4',
                                    partial_index: 'partial_2',
                                    color: 'transparent',
                                    partial: 'transparent'
                                })
                            } else if (item.visualLumen === 'Clotted Partial') {
                                // 3 dots
                                this.$store.commit('UPDATE_SSV_DOT_COLORS', {
                                    index: 'dot_3',
                                    partial_index: 'partial_2',
                                    color: 'transparent',
                                    partial: 'black'
                                })
                                this.$store.commit('UPDATE_SSV_DOT_COLORS', {
                                    index: 'dot_4',
                                    partial_index: 'partial_2',
                                    color: 'transparent',
                                    partial: 'black'
                                })
                            } else {
                                // 6 dots
                                this.$store.commit('UPDATE_SSV_DOT_COLORS', {
                                    index: 'dot_3',
                                    partial_index: 'partial_2',
                                    color: 'black',
                                    partial: 'transparent'
                                })
                                this.$store.commit('UPDATE_SSV_DOT_COLORS', {
                                    index: 'dot_4',
                                    partial_index: 'partial_2',
                                    color: 'black',
                                    partial: 'transparent'
                                })
                            }
                        }
                        if (item.name === 'SPJ') {
                            if (item.refluxTime < 0.5) {
                                // Blue color
                                this.$store.commit('UPDATE_SSV_COLORS', {index: 'color_ssv_1', color: '#8ec4dd'})
                            } else if (item.refluxTime >= 0.5 && item.refluxTime < 1) {
                                // Red Color
                                this.$store.commit('UPDATE_SSV_COLORS', {index: 'color_ssv_1', color: '#FF2735'})
                            } else {
                                // Dark red Color
                                this.$store.commit('UPDATE_SSV_COLORS', {index: 'color_ssv_1', color: '#800000'})
                            }

                            if (item.visualLumen === 'Phasic Flow') {
                                // Transparent
                                this.$store.commit('UPDATE_SSV_DOT_COLORS', {
                                    index: 'dot_1',
                                    partial_index: 'partial_1',
                                    color: 'transparent',
                                    partial: 'transparent'
                                })
                                this.$store.commit('UPDATE_SSV_DOT_COLORS', {
                                    index: 'dot_2',
                                    partial_index: 'partial_1',
                                    color: 'transparent',
                                    partial: 'transparent'
                                })
                            } else if (item.visualLumen === 'Clotted Partial') {
                                // 3 dots
                                this.$store.commit('UPDATE_SSV_DOT_COLORS', {
                                    index: 'dot_1',
                                    partial_index: 'partial_1',
                                    color: 'transparent',
                                    partial: 'black'
                                })
                                this.$store.commit('UPDATE_SSV_DOT_COLORS', {
                                    index: 'dot_2',
                                    partial_index: 'partial_1',
                                    color: 'transparent',
                                    partial: 'black'
                                })
                            } else {
                                // 6 dots
                                this.$store.commit('UPDATE_SSV_DOT_COLORS', {
                                    index: 'dot_1',
                                    partial_index: 'partial_1',
                                    color: 'black',
                                    partial: 'transparent'
                                })
                                this.$store.commit('UPDATE_SSV_DOT_COLORS', {
                                    index: 'dot_2',
                                    partial_index: 'partial_1',
                                    color: 'black',
                                    partial: 'transparent'
                                })
                            }
                        }
                    }
                })
            },

            async getVeinImage() {
                await StudyService.getVeinSvg()
                    .then((response) => {
                        this.images = [];
                        this.images = response;
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            },

            date_format(date, format) {
                return (date) ? moment(date).format(format) : null;
            },

            selectSvg(id, type) {
                this.veinType = type
                this.clear()
                this.selectedSvg = id
                const svg = document.getElementById(id)
                const svgString = svg.innerHTML
                //const svgData = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svgString)));
                this.$refs.editor.setBackgroundSvg(svgString)
            },

            svgString2Image(svgString, width, height, format, callback) {
                format = format ? format : 'svg';
                var svgData = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svgString)));
                var canvas = document.getElementById('canvasId');
                var context = canvas.getContext('2d');
                context.fillStyle = "#545456";
                context.fillRect(0, 0, width, height);
                var image = new Image();
                image.onload = function () {
                    var w = height * image.width / image.height;
                    context.drawImage(image, width / 2 - w / 2, 0, w, height);
                    var pngData = canvas.toDataURL('image/' + format);
                    callback(pngData);
                };
                image.src = svgData;
            },

            undo() {
                this.$refs.editor.undo()
            },

            redo() {
                this.$refs.editor.redo()
            },

            saveImage() {
                const image = this.$refs.editor.saveImage()
                this.download('draw.png', image)
            },

            resetZoom() {
                this.$refs.editor.resetZoom()
            },

            sendImage() {
                this.resetZoom()
                const image = this.$refs.editor.saveImage()
                let Laterality = this.getRequestParam('laterality')
                if (this.getRequestParam('studySubTab') == 'ssv') {
                    this.veinType = 'Deep'
                }
                else {
                    this.veinType = 'GSV'
                }
                Laterality = Laterality.charAt(0).toUpperCase() + Laterality.slice(1)
                let string = image.split(',')
                const base64 = string[1]
                let block = image.split(";");
                let contentType = block[0].split(":")[1];
                const file = this.b64toBlob(base64, contentType)
                const formData = new FormData();
                formData.append('file', file)

                const payload = {
                    StudyId: this.study.id,
                    VeinType: this.veinType,
                    Laterality: Laterality,
                }

                this.$store.dispatch('studyInfoStore/getVeinSvg', this.serialize(payload))
                    .then((response) => {
                        if (!response.data) {
                            for (const [key, value] of Object.entries(payload)) {
                                if (value !== null) {
                                    formData.append(key, value);
                                }
                            }
                            const responseData = this.$store.dispatch('studyInfoStore/saveVeinSvg',formData)
                            if (!responseData.errors) {
                                const success_message = " Image Saved";
                                this.$toastr.Add({
                                    msg: success_message,
                                    clickClose: true,
                                    type: "success",
                                });
                            }else {
                                const error_message = responseData.errors[Object.keys(responseData.errors)[0]][0]
                                this.$toastr.Add({
                                    msg: error_message,
                                    clickClose: true,
                                    type: "error",
                                });
                            }
                        } else {
                            formData.append('id', response.data.id)
                            formData.append('Laterality', Laterality)
                            formData.append('VeinType', this.veinType)
                            const payload = {
                                id: response.data.id,
                                credentials: formData
                            }
                            const responseData = this.$store.dispatch('studyInfoStore/editVeinSvg',payload)
                            if (!responseData.errors) {
                                const success_message = "Image successfully updated!";
                                this.$toastr.Add({
                                    msg: success_message,
                                    clickClose: true,
                                    type: "success",
                                });
                            } else {
                                const error_message = responseData.errors[Object.keys(responseData.errors)[0]][0]
                                this.$toastr.Add({
                                    msg: error_message,
                                    clickClose: true,
                                    type: "error",
                                });
                            }
                        }
                    })
                    .catch(() => {

                    });
            },

            b64toBlob(b64Data, contentType = '', sliceSize = 512) {
                const byteCharacters = atob(b64Data);
                const byteArrays = [];

                for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                    const slice = byteCharacters.slice(offset, offset + sliceSize);

                    const byteNumbers = new Array(slice.length);
                    for (let i = 0; i < slice.length; i++) {
                        byteNumbers[i] = slice.charCodeAt(i);
                    }

                    const byteArray = new Uint8Array(byteNumbers);
                    byteArrays.push(byteArray);
                }

                const blob = new Blob(byteArrays, {type: contentType});
                return blob;
            },

            serialize(obj) {
                var str = "";
                for (var key in obj) {
                    if (obj[key] !== null) {
                        if (str != "") {
                            str += "&";
                        }
                        str += key + "=" + encodeURIComponent(obj[key]);
                    }

                }

                return str;
            },

            download(filename, file) {
                var element = document.createElement('a');
                element.setAttribute('href', file);
                element.setAttribute('download', filename);

                element.style.display = 'none';
                document.body.appendChild(element);

                element.click();

                document.body.removeChild(element);
            },

            setArrow() {
                let customizeArrow = {stroke: 'red', strokeWidth: "3"}
                this.$refs.editor.set('arrow', customizeArrow)
            },

            setLine() {
                let customizeLine = {stroke: this.default_color, strokeWidth: this.default_strock}
                this.$refs.editor.set('line', customizeLine)
            },

            addText() {
                this.$refs.editor.set('text')
            },

            draw() {
                let customizeFreeDrawing = {stroke: this.default_color, strokeWidth: this.default_strock}
                this.$refs.editor.set('freeDrawing', customizeFreeDrawing)
            },

            selectColor(color) {
                this.default_color = color
                let customizeFreeDrawing = {stroke: this.default_color, strokeWidth: this.default_strock}
                this.$refs.editor.set('freeDrawing', customizeFreeDrawing)
                let customizeLine = {stroke: this.default_color, strokeWidth: this.default_strock}
            },

            selectStorck() {
                let customizeFreeDrawing = {stroke: this.default_color, strokeWidth: this.default_strock}
                this.$refs.editor.set('freeDrawing', customizeFreeDrawing)
                let customizeLine = {stroke: this.default_color, strokeWidth: this.default_strock}
                this.$refs.editor.set('line', customizeLine)
            },

            clear() {
                this.resetZoom()
                this.$refs.editor.clear()
            },

            deleteObject() {
                this.$refs.editor.deleteObject()
            },

            selectItem() {
                this.$refs.editor.set('selectMode')
            },

            zoomIn() {
                this.$refs.editor.zoomIn()
            },

            zoomOut() {
                this.$refs.editor.zoomOut()
            },

            backPage() {
                let name = this.prevRoute.name
                if (name === null) {
                    let tab = this.getRequestParam('studyTab')
                    if (typeof tab !== "undefined" && tab !== "undefined") {
                        name = 'Dashboard'
                    } else {
                        name = 'WorkingSpace'
                    }
                }
                this.$router.push({
                    name: name,
                    query: {
                        studyId: this.study.id,
                        studyTab: this.getRequestParam('studyTab'),
                        studySubTab: this.getRequestParam('studySubTab'),
                        laterality: this.getRequestParam('laterality'),
                        image: this.getRequestParam('image')
                    }
                })
            }

        }
    }
</script>
<style scoped>
    #working_space .panel-group.study-info .panel-body.scrolling {
        min-height: 101px !important;
    }

    .svg-image {
        width: 150px;
        height: auto;
    }

    .svg-images {
        margin-right: 30px;
    }

    .svg-images div {
        background-color: rgb(84, 84, 86);
    }

    .svg-images .active {
        border: 2px solid #00D5FF;
    }


    .back {
        margin-top: 10px;
        width: 150px;
        height: auto;
    }

    .ssv_drawing_space {
        margin-left: 35px;
        height: 100%;
    }

    .canvas-tools {
        margin-left: 35px;
        background-color: #4c525e;
        height: auto;
        width: 850px;
    }

    .canvas-tools button, .canvas-tools select {
        border: none;
        color: white;
        background-color: transparent;
        width: 45px;
        height: 35px;
    }

    .canvas-tools .color {
        margin-left: 5px;
        width: 15px;
        height: 15px;
    }

    .canvas-tools button:hover {
        background-color: rgba(0, 213, 255, 0.5);
    }

    .canvas-tools button svg {
        font-size: 20px;
    }

    .custom-editor {
        position: relative;
        user-select: none;
        align-items: center;
        background-color: #fff;
        border: 1px solid #68859F;
        display: flex;
        justify-content: center;
        overflow: hidden;
        width: 850px;
    }

    .svg-name {
        background-color: rgba(30, 30, 30, 0.6);
        bottom: 0;
        font-size: 14px;
        letter-spacing: 0.8px;
        line-height: 19px;
        left: 0;
        padding: 2px 22px 3px;
        text-align: center;
        z-index: 1;
    }

    .save-svg {
        margin-right: 14px;
        background-color: #00D5FF !important;
        border: 0.6px solid #00D5FF !important;
        color: #181A1E;
        font-size: 12px;
        letter-spacing: 0;
        padding: 4px 30px;
        margin-top: 4px;
        text-transform: uppercase;
        cursor: pointer;
    }

    .discard-svg {
        margin-right: 9px;
        background-color: #858585 !important;
        border: 0.6px solid #858585 !important;
        font-size: 12px;
        letter-spacing: 0;
        padding: 4px 30px;
        margin-top: 4px;
        text-transform: uppercase;
        cursor: pointer;
    }

    .svg-zoom {
        margin-left: 7px;
    }

    .pen-size {
        border: 1px solid gray !important;
        width: 35px !important;
        height: 27px !important;
    }
</style>